import { useQuery } from "@tanstack/react-query";
import { GET_SCHOOLS_FOR_DISTRICT } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { useReactQueryErrorReporter } from "./use-error-reporter";

const fetchSchools = async ({ queryKey }) => {
  const [, { parentID }] = queryKey;
  const { getSchoolsForDistrict } = await graphQLClient.request(
    GET_SCHOOLS_FOR_DISTRICT,
    {
      parentID,
    },
  );
  return getSchoolsForDistrict;
};

export const useFetchSchools = (assignedDistrict) => {
  const { error, ...rest } = useQuery({
    queryKey: ["fetchSchools", { parentID: assignedDistrict }],
    queryFn: fetchSchools,
    enabled: !!assignedDistrict,
  });

  useReactQueryErrorReporter("Error fetching schools for district", error);

  return { error, ...rest };
};
